import { Component, OnInit, OnDestroy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Subject, takeUntil, timer } from 'rxjs';
import { ChatStateService } from '../../../../core/services/chat-state.service';

@Component({
  selector: 'app-notification-banners',
  imports: [CommonModule],
  templateUrl: './notification-banners.component.html',
  styleUrls: []
})
export class NotificationBannersComponent implements OnInit, OnDestroy {
  error: string | null = null;
  successMessage: string | null = null;

  private destroy$ = new Subject<void>();

  constructor(public chatState: ChatStateService) { }

  ngOnInit(): void {
    this.chatState.error$.pipe(takeUntil(this.destroy$)).subscribe(
      error => {
        this.error = error;
        if (error) {
          timer(5000).pipe(takeUntil(this.destroy$)).subscribe(() => {
            if (this.error === error) this.chatState.setError(null);
          });
        }
      }
    );

    this.chatState.successMessage$.pipe(takeUntil(this.destroy$)).subscribe(
      message => {
        this.successMessage = message;
        if (message) {
          timer(5000).pipe(takeUntil(this.destroy$)).subscribe(() => {
            if (this.successMessage === message) this.chatState.setSuccessMessage(null);
          });
        }
      }
    );
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
